import { Pipe, PipeTransform } from '@angular/core';
import { Observable, zip } from 'rxjs';
import { map, take } from 'rxjs/operators';
import isEmpty from 'lodash-es/isEmpty';

import {
  BookingPaxTypeDocumentProps, BookingPaxDocumentRules
} from '@app/entities/booking-documents';
import { TravelerTypes } from '@pax/entities/traveler-info';
import { PaxFacade } from '@pax/pax.facade';
import { environment as ENV } from '@environment';
import { getTravelerDocumentsByBookingType } from '@pax/mappers/pax-traveler-documents.mapper';
import { AppFacade } from '@app/app.facade';

@Pipe({
  name: 'paxTypeDocuments',
  standalone: false
})
export class PaxDocumentsPipe implements PipeTransform {

  constructor(
    private facade: PaxFacade,
    private appFacade: AppFacade,
  ) { }

  transform(
    travelerType: TravelerTypes,
    nationality: string
  ): Observable<BookingPaxTypeDocumentProps[]> {
    return zip(
      this.appFacade.isAnInternationalSearch$.pipe(take(1)),
      this.facade.bookingType$,
      this.appFacade.documentAssets$
    ).pipe(
      map(([isAnInternationalTrip, bookingType, _ENV]) => {
        return {
          isAnInternationalTrip,
          bookingType,
          documents: getTravelerDocumentsByBookingType(_ENV, travelerType, bookingType),
        };
      }),
      map(({ isAnInternationalTrip, documents, bookingType }) => {
        return documents.filter(_document => {
          const validations = _document?.VALIDATIONS?.DOCUMENT_BUSINESS_RULES_BY_MODULES &&
            _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] ?
            _document.VALIDATIONS.DOCUMENT_BUSINESS_RULES_BY_MODULES[bookingType] :
            {} as BookingPaxDocumentRules;
          if (!isEmpty(validations)) {
            const tripCondition = isAnInternationalTrip ? !!validations.INTERNATIONAL_TRIP : !!validations.NATIONAL_TRIP;
            if (validations.ONLY_NATIONAL_CITIZENS && nationality) {
              return tripCondition && nationality === ENV.countryInfo.iso_code;
            } else return tripCondition;
          } else return true;
        });
      })
    );
  }
}
